import { connect } from 'react-redux';
import { actions, selectors } from 'app-webtech-core';
import { VOD, WATCH } from 'app-source/routes/types';
import { properties as embedSelector } from 'app-modules/embed/selectors';
import { TYPE as EMBED_TYPE } from 'app-modules/embed/constants';
import { EmbedHeaderComponent } from '../components/EmbedHeader';
import { checkMobileOperatingSystem } from '../utils/checkMobileOperatingSystem';
import { enterFullscreen, exitFullscreen, exitFullscreenSplashPage } from '../../player/actions';
import { sectionSelect } from '../utils/sectionSelect';

const mapStateToProps = (state, ownProps) => {
  const { isFullscreen, mute: isMuted, content } = selectors.player.properties(state);
  const embedState = embedSelector(state);
  const isHeadless = embedState.type === EMBED_TYPE.EMBED_TYPE_HEADLESS;
  const { isIos, isAndroid } = checkMobileOperatingSystem();
  const player = selectors.player.properties(state);
  const isMobile = isIos || isAndroid;
  return {
    isFullscreen,
    isMobile,
    isHeadless,
    page: state.page,
    enableVOD: selectors.application.enableVOD(state),
    isMuted,
    volume: player.volume,
    channelSlug: content && content.slug,
  };
};

const mapDispatchToProps = (dispatch) => ({
  redirectToWatch: () => sectionSelect(dispatch, WATCH),
  redirectToVod: () => sectionSelect(dispatch, VOD),
  linkClickBeacon: () => dispatch(actions.application.linkClick()),
  hideGuide: () => dispatch(enterFullscreen()),
  showGuide: () => {
    dispatch(exitFullscreen());
    dispatch(exitFullscreenSplashPage());
  },
  unmute: () => dispatch(actions.player.unmute()),
  mute: () => dispatch(actions.player.mute()),
  volumeChange: (args) => dispatch(actions.player.volumeChange(args)),
});

export const EmbedHeader = connect(mapStateToProps, mapDispatchToProps)(EmbedHeaderComponent);
